import { useEffect, useState } from 'react';
import { Alert, Button } from '../components';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import classNames from 'classnames';
import { useCountry } from '@/hooks/use-country';

interface IProps {
  open: boolean;
  type?: 'warning' | 'info' | 'error' | 'attention' | 'success';
  className?: string;
  title: string;
  messages: string[];
  onClose?: () => void;
}

export function ViewMoreMessage({ open, type = 'info', className, title, messages, onClose }: IProps) {
  return (
    <Alert
      open={open}
      onClose={onClose}
      type={type}
      className={classNames('print:hidden', className)}
      title={title}
      content={<Messages messages={messages} />}
    />
  );
}

function Messages({ messages }: { messages: string[] }) {
  const [expanded, setExpanded] = useState(false);
  const [showMessages, setShowMessages] = useState([]);
  const { isKR } = useCountry();
  const { t } = useLang(NAMESPACE.common);

  useEffect(() => {
    if (isKR) {
      setShowMessages(messages.slice(0, 2));
    } else {
      setExpanded(true);
    }
  }, []);

  useEffect(() => {
    if (expanded) {
      setShowMessages(messages);
    } else {
      setShowMessages(messages.slice(0, 2));
    }
  }, [expanded]);

  const handleShowAllClick = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <ul className="m-0 text-gray-900">
        {showMessages.map((item, index) => {
          return <li key={index} dangerouslySetInnerHTML={{ __html: item }}></li>;
        })}
      </ul>
      {messages.length > 2 && (
        <>
          {expanded && (
            <Button onClick={handleShowAllClick} type="link" className="font-normal h-fit leading-none mt-2">
              {t('view.less')}
            </Button>
          )}
          {!expanded && (
            <Button onClick={handleShowAllClick} type="link" className="font-normal h-fit leading-none mt-2">
              {t('view.all')}
            </Button>
          )}
        </>
      )}
    </>
  );
}
